import React, { useState, useEffect } from "react";
import cx from "clsx";
import { Transition } from "react-transition-group";

import Logo from "@/components/shared/logo";
import ModalCloseButton from "@/components/shared/modalCloseButton";
import BldgE1Img from "@/images/tour/e1.png";
import BldgE2Img from "@/images/tour/e2.png";
import BldgE3Img from "@/images/tour/e3.png";
import BldgE4Img from "@/images/tour/e4.png";
import ArrowsOutSvg from "@/images/tour/arrows-out.svg";
// import Tour from "@/assets/tour.js";

import globalStyles from "@/styles/global.module.scss";
import styles from "./threeSixtyModal.module.scss";

const ICONS = {
  e1: BldgE1Img,
  e2: BldgE2Img,
  e3: BldgE3Img,
  e4: BldgE4Img
};
const DELAY = 330;

const ThreeSixtyModal = props => {
  const { isDesktop, visible, panoIndex, bldg, label, onClose } = props;

  // const [hasMounted, setHasMounted] = useState(false);
  const [wasTouched, setWasTouched] = useState(false);
  const [animationReady, setAnimationReady] = useState(false);
  const handleTouchStart = () => {
    if (!wasTouched) setWasTouched(true);
  };
  const memoSetAnimationReady = val => () => setAnimationReady(val);

  useEffect(() => {
    // if (!hasMounted) setHasMounted(true);
    if (!animationReady) setTimeout(memoSetAnimationReady(true), DELAY);

    if (!visible) return;
    //
  });

  return (
    <div
      role="button"
      tabIndex={-1}
      className={styles.container}
      onTouchStart={handleTouchStart}
      onMouseDown={handleTouchStart}
    >
      <Logo hidden={!isDesktop} className={styles.logo} />

      {isDesktop ? (
        <Transition enter exit in={animationReady} timeout={0}>
          {state => (
            <div className={styles.desktopLabelContainer}>
              <div
                className={cx(
                  styles.desktopLabel,
                  globalStyles.opacityAnimation,
                  globalStyles[state]
                )}
              >
                {label}
              </div>
            </div>
          )}
        </Transition>
      ) : null}

      {!isDesktop ? (
        <>
          <div className={styles.logoContainer}>
            <img className={styles.bldgImg} src={ICONS[bldg]} alt={label} />
          </div>
          <div className={styles.bldgLabel}>{label}</div>
        </>
      ) : null}

      <ModalCloseButton isDesktop={isDesktop} onClick={onClose} />

      {!wasTouched ? (
        <div className={styles.touchContainer}>
          <div className={styles.touchInner}>
            <ArrowsOutSvg className={styles.arrowsSvg} alt="arrows" />
            <div className={styles.touchLabel}>DRAG TO ACTIVATE 360° PANO</div>
          </div>
        </div>
      ) : null}

      <div
        role="button"
        tabIndex={-1}
        className={styles.iframeContainer}
        onTouchStart={handleTouchStart}
        onMouseDown={handleTouchStart}
      >
        {/* eslint-disable */}
        <iframe
          src={`/pano_e${panoIndex}/index.html`}
          title={`Pano ${panoIndex}`}
          className={styles.iframe}
          onTouchStart={handleTouchStart}
          onMouseDown={handleTouchStart}
        />
        {/* eslint-enable */}
      </div>
    </div>
  );
};

export default ThreeSixtyModal;
